import React from "react";

const Title = props => <p className="tit">{ props.children ? `Q. ${ props.children }` : '' }</p>;

export default Title;
